import { defineAsyncComponent } from 'vue';

export default () => defineAsyncComponent(() => import(/* webpackChunkName: "ZipcodeSlideout", webpackPrefetch: true */ './ZipcodeSlideout'));
